<template>
  <div v-if="hospIdShow" class="page flex-col">
    <div class="group_2 flex-col">
      <img
        class="image_3"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng0a9975edeae4f4a204be7eb6a8a131447a1a41d7e4b38a29d1883ac636da724a.png"/>
      <span class="text_3"></span>
      <div class="image-text_1 flex-col">
        <span class="text-group_1"></span>
      </div>
      <van-divider :style="{ color: '#fa8a19', borderColor: '#fa8a19', padding: '0 16px' }">个人绑定信息</van-divider>
      <van-tabs v-model:active="active">
        <van-tab title="绑定信息">
          <van-form>
            <br />
            <van-cell-group inset>
              <van-notice-bar
                scrollable
                left-icon="volume-o"
                text="已经核验通过的申请，再次修改请联系机构人员"/>
              <van-field
                v-model="registerData.realName"
                required
                label="真实姓名"
                :rules="[{ required: true, message: '请填写姓名' }]"/>
              <van-field
                v-model="registerData.phone"
                required
                label="手机号码"
                :rules="[
                  { required: true },
                  {
                    pattern: /^1[3456789]\d{9}$/,
                    message: '手机号码格式错误！',
                  },
                ]"/>
              <van-field
                v-model="registerData.hospitalName"
                required
                label="服务机构"
                :rules="[{ required: true, message: '请填写手机号' }]"/>
            </van-cell-group>
          </van-form>
          <van-divider
            :style="{
              color: '#fa8a19',
              borderColor: '#fa8a19',
              padding: '0 16px',
            }">相关协议签署</van-divider>
          <van-checkbox v-model="registerData.informed">同意并签署如下协议：</van-checkbox>
          <p class="textIndentation">
            <router-link to="/userServiceAgreement">《用户服务协议》</router-link>
            <router-link to="/privacyAgreement">、《隐私服务协议》</router-link>
            <router-link to="/informedConsent">、《知情同意书》</router-link>
          </p>
          <div style="margin: 16px">
            <van-button
              v-if="buttonShow"
              round
              block
              color="linear-gradient(to right, #f67f34, #d55809)"
              disabled
              native-type="submit"
              @click="getData"
              >{{ submitContext }}</van-button
            >
            <van-button
              v-else
              round
              block
              color="linear-gradient(to right, #f67f34, #d55809)"
              native-type="submit"
              @click="getData"
              >{{ submitContext }}</van-button
            >
          </div>
          <van-divider v-if="doctorButton"
            :style="{
              color: '#fa8a19',
              borderColor: '#fa8a19',
              padding: '0 16px',
            }">院端入口</van-divider>
          <br/>
          <van-grid  v-if="doctorButton" :gutter="10">
              <!--van-grid-item icon="wap-home-o" text="数据汇总" to="hospBi"/-->
              <van-grid-item icon="manager-o" text="体检科" to="hospUser"/>
              <!--van-grid-item icon="cluster-o" text="团检企业" /-->
              <van-grid-item icon="apps-o" text="医生服务"  to="doctorIndex"/>
          </van-grid>
          <!--van-divider v-if="doctorButton"
            :style="{
              color: '#fa8a19',
              borderColor: '#fa8a19',
              padding: '0 16px',
            }">企业入口</van-divider>
          <br/>
          <van-grid  v-if="doctorButton" :gutter="10">
              <van-grid-item icon="user-o" text="员工管理" />
              <van-grid-item icon="shield-o" text="风险监测" />
              <van-grid-item icon="link-o" text="体检安排" />
          </van-grid-->
        </van-tab>
        <van-tab title="调研数据">
          <van-form @submit="onSubmit">
            <br />
    <van-space direction="vertical" size="2rem" fill>
      <van-row>
        <van-col offset="0.5" span="24">
          <van-cell-group inset>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false">
              （1）、您的年龄是否大于40岁？
            </van-notice-bar>
            <van-cell>
              <van-radio-group
                v-model="question.userRiskInfoVo.yearOld"
                direction="horizontal">
                <van-radio name="1" icon-size="24px">是</van-radio>
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false">
              （2）、您的性别是？
            </van-notice-bar>
            <van-cell>
              <van-radio-group
                v-model="question.userRiskInfoVo.gender"
                direction="horizontal">
                <van-radio name="1" icon-size="24px">男</van-radio>
                <van-radio name="2" icon-size="24px">女</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false">
              （3）、您是否是吸烟者？(每周吸烟)
            </van-notice-bar>
            <van-cell>
              <van-radio-group
                v-model="question.userRiskInfoVo.smoking"
                direction="horizontal">
                <van-radio name="1" icon-size="24px">是</van-radio>
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false">
              （4）、您的父母55岁之前是否患有冠心病？
            </van-notice-bar>
            <van-cell>
              <van-radio-group
                v-model="question.userRiskInfoVo.yichuan"
                direction="horizontal">
                <van-radio name="1" icon-size="24px">是</van-radio>
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false">
              （5）、您是否患有糖尿病？
            </van-notice-bar>
            <van-cell>
              <van-radio-group
                v-model="question.userRiskInfoVo.diabetes"
                direction="horizontal">
                <van-radio name="1" icon-size="24px">是</van-radio>
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false">
              （6）、您是否已经服用降压药(西药)？
            </van-notice-bar>
            <van-cell>
              <van-radio-group v-model="question.userRiskInfoVo.xueyayao"  direction="horizontal">
                <van-radio name="1" icon-size="24px">是</van-radio>
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false">
              （7）、您是否已经服用降脂药(西药)？
            </van-notice-bar>
            <van-cell>
              <van-radio-group v-model="question.userRiskInfoVo.xuezhiyao"  direction="horizontal">
                <van-radio name="1" icon-size="24px">是</van-radio>
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
          </van-cell-group>
        </van-col>
      </van-row>
    </van-space>
    <div style="margin: 16px">
      <van-button
        color="linear-gradient(to right, #f67f34, #d55809)"
        round
        block
        native-type="submit"
        @click="getQueSave">保存修订</van-button>
    </div>
  </van-form>
        </van-tab>
      </van-tabs>
    </div>
  </div>
  <div v-else class="page flex-col">
    <div class="group_2 flex-col">
      <img
        class="image_3"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng0a9975edeae4f4a204be7eb6a8a131447a1a41d7e4b38a29d1883ac636da724a.png"/>
      <span class="text_3"></span>
      <div class="image-text_1 flex-col">
        <span class="text-group_1"></span>
      </div>
      <span class="text_4">机构绑定</span>
      <div class="group_3 flex-col">
        <div class="text-group_2 flex-col">
          <van-form>
            <p class="text2Indentation">
              本次绑定需要填写，您在机构服务时预留的个人信息。
          </p>
          <p class="text2Indentation">
              机构绑定申请后会有审核环节，请您务必保证填写的信息完整、准确。
          </p>
          </van-form>
          <van-divider
            :style="{
              color: '#fa8a19',
              borderColor: '#fa8a19',
              padding: '0 16px',
            }">相关协议签署</van-divider>
          <van-checkbox v-model="informedRes">同意并签署如下协议：</van-checkbox>
          <p class="textIndentation">
            <router-link to="/userServiceAgreement">《用户服务协议》</router-link>
            <router-link to="/privacyAgreement">、《隐私服务协议》</router-link>
            <router-link to="/informedConsent">、《知情同意书》</router-link>
          </p>
          <div style="margin: 8px">
            <van-button
              round
              block
              color="linear-gradient(to right, #f67f34, #d55809)"
              native-type="submit"
              @click="getNewData">开始绑定</van-button
            >
          </div>
        </div>
      </div>
      <van-divider v-if="doctorButton"
            :style="{
              color: '#fa8a19',
              borderColor: '#fa8a19',
              padding: '0 16px',
            }">院端入口</van-divider>
          <br/>
          <van-grid  v-if="doctorButton" :gutter="10">
              <!--van-grid-item icon="wap-home-o" text="团检企业" /-->
              <van-grid-item icon="manager-o" text="客户管理" />
              <!--van-grid-item icon="cluster-o" text="绿通追踪" /-->
              <van-grid-item icon="apps-o" text="医生入口"  to="doctorIndex"/>
          </van-grid>
          <!--van-divider v-if="doctorButton"
            :style="{
              color: '#fa8a19',
              borderColor: '#fa8a19',
              padding: '0 16px',
            }">企业入口</van-divider>
          <br/>
          <van-grid  v-if="doctorButton" :gutter="10">
              <van-grid-item icon="user-o" text="员工管理" />
              <van-grid-item icon="shield-o" text="风险监测" />
              <van-grid-item icon="link-o" text="体检安排" />
          </van-grid-->
    </div>
  </div>
  <van-popup
        v-model:show="showStep"
        round
        closeable
        close-icon="close"
        position="bottom"
        :style="{ height: '10%' }">
        <van-notice-bar wrapable :scrollable="false" left-icon="info-o">
          {{ popupTx }}
        </van-notice-bar>
      </van-popup>
  <van-overlay :show="showBinging" @click="showBinging = false">
    <div class="wrapper" @click.stop>
      <div class="block">
        <van-cell-group inset>
          <van-notice-bar
            wrapable
            :scrollable="false"
            text="提交申请成功"
            left-icon="info-o"
          />
          <p class="textIndentation">
            <van-notice-bar
              wrapable
              :scrollable="false"
              color="#1989fa"
              background="#ffffff"
              text="信息提交完成，我们需要【1-3个工作日】进行审核！"/>
          </p>
          <van-button
            v-if="goToAbout"
            type="warning"
            block
            plain
            hairline
            to="about">
            返回项目介绍
          </van-button>
        </van-cell-group>
      </div>
    </div>
  </van-overlay>
  <van-overlay :show="showOverlay" @click="showOverlay = false">
    <div class="wrapper" @click.stop>
      <div class="block">
        <van-cell-group inset>
          <van-notice-bar
            wrapable
            :scrollable="false"
            text="服务提醒"
            left-icon="info-o"/>
          <p class="textIndentation">
            <van-notice-bar
              wrapable
              :scrollable="false"
              color="#1989fa"
              background="#ffffff"
              >{{ bingingNotice }}</van-notice-bar>
          </p>
          <van-button
            v-if="goToUserInfo"
            type="warning"
            block
            plain
            hairline
            @click="showOverlay = false"
          >
            关闭
          </van-button>
          <van-button
            v-if="goToAbout"
            type="warning"
            block
            plain
            hairline
            to="about"
          >
            返回项目介绍
          </van-button>
        </van-cell-group>
      </div>
    </div>
  </van-overlay>
</template>
<script>
import { ref, toRefs, reactive, onMounted } from "vue";
import { postHospAndMobile, getPersonInit } from "../../api/register";
import { getCheckBinding } from "../../api/permission";
import { postUserRiskInfo,getUserRiskInfo } from "../../api/queInfo";
import { postUserLog } from "../../api/userlog";
import { useRouter } from "vue-router";
import { showDialog } from "vant";
export default {
  setup() {
    const showBinging = ref(false);
    const active = ref(0);
    const result = ref(['']);
    const showPicker = ref(false);
    const currentDate = ref(['1975', '01']);
    const columnsType = ['year', 'month'];
    const informedRes=ref(false);
    const hospIdShow = ref(false);
    const submitContext = ref("提交申请");
    const showOverlay = ref(false);
    const goToAbout = ref(false);
    const goToUserInfo = ref(false);
    const bingingNotice = ref("");
    const buttonShow = ref(false);
    const doctorButton = ref(false);
    const router = useRouter();
    const ulog = reactive({
      UserLog: {
        path: "",
      },
    });
    const onConfirm = ({ selectedValues }) => {
      result.value = selectedValues.join('/');
      showPicker.value = false;
    };
    const kpianawait = reactive({
      cellGroupBackground: "#F1F1F1",
    });
    const state = reactive({
      registerData: {
        hospitalName: "",
        hospitalCode: "",
        realName: "",
        nowHospName: "",
        nowHospCode: "",
        phone: "",
        idCard: "",
        smsBindingCode: "",
        informed: "",
        isDoctor: "",
      },
    });
    const question = reactive({
      userRiskInfoVo: {
        smoking: "",
        diabetes: "",
        yichuan: "",
        xuezhiyao: "",
        xueyayao: "",
        gender:"",
        birthday:"",
        yearOld:"",
      },
    });
    const hosp = reactive({
      HospInfo: {
        hospId: "",
      },
    });
    const getQueSave = () => {
      console.log(question.userRiskInfoVo.diabetes);
      if(question.userRiskInfoVo.diabetes == "" ||
        question.userRiskInfoVo.smoking == "" ||
        question.userRiskInfoVo.yichuan == "" ||
        question.userRiskInfoVo.xuezhiyao == "" ||
        question.userRiskInfoVo.xueyayao == "" ){
          showDialog({
            title: "错误提醒",
            message: "请填写必要的绑定信息!",
            theme: "round-button",
          }).then(() => {
            
          });
      }else{
        //console.log(result);
        //question.userRiskInfoVo.birthday=result.value;
        postUserRiskInfo(question.userRiskInfoVo).then((res) => {
          console.log(question.userRiskInfoVo);
          console.log(res.data.code);
          if (res.data.code == 0) {
            console.log("绑定成功");
            showDialog({
                title: "完成提交",
                theme: "round-button",
          }).then(() => {
            location.reload();
          });
          } else {
            console.log("绑定失败，失败原因:" + res.data.message);
          }
        });
      }
    };
    const getData = () => {
      if (state.registerData.informed == null || state.registerData.informed == 0) {
        showDialog({
            title: "错误提醒",
            message: "您尚未开通医生服务功能！这部分功能仅为医生提供服务使用",
            theme: "round-button",
          }).then(() => {
          });
      } else {
        postHospAndMobile(state.registerData).then((res) => {
          console.log(res.data.code);
          if (res.data.code == 0) {
            console.log("绑定成功");
            showOverlay.value = true;
            hospIdShow.value = true;
            bingingNotice.value =
              "【审核中】：我们会在1～3个工作日内完成，感谢您的等待！";
            goToUserInfo.value = true;
            submitContext.value = "审核中";
            buttonShow.value = true;
          } else {
            showOverlay.value = true;
            bingingNotice.value = "【绑定异常】：数据异常，请提交准确的数据";
            goToUserInfo.value = true;
            console.log("绑定失败，失败原因:" + res.data.message);
          }
        });
      }
    };
    const getNewData = () => {
      if (informedRes.value) {
        const exp=router.currentRoute.value.query.hospId;
       if (exp== undefined || exp == null||exp == '')
        {
          router.push('bindingStepHosp');
        }else{
          router.push({
            path: 'bindingStepHosp',
            query: {hospId:exp}
          });
        }
      } else{
        showDialog({
            title: "错误提醒",
            message: "您需要先签署相关协议!",
            theme: "round-button",
          }).then(() => {
            
          });
      }
    };
    onMounted(() => {
      ulog.UserLog.path = router.currentRoute.value.fullPath;
      console.log("当前页面路径==" + ulog.UserLog.path);
      postUserLog(ulog.UserLog).then(() => {});
    
      getCheckBinding().then((res1) => {
        const binding = res1.data.code;
        console.log("返回绑定状态=="+binding);
        if (binding == 60002) {
          showOverlay.value = true;
          hospIdShow.value = true;
          bingingNotice.value =
            "【审核中】：我们会在1～3个工作日内完成，感谢您的等待！";
          goToUserInfo.value = true;
          submitContext.value = "审核中";
          buttonShow.value = true;
          state.registerData = res1.data.data;
          if (state.registerData != null && state.registerData.isDoctor == "1") {
            doctorButton.value = true;
          }
          console.log(state.registerData);
        } else if (binding == 60003) {
          hospIdShow.value = false;
          showOverlay.value = true;
          bingingNotice.value = "请准确、完整填写您在机构预留信息";
          state.registerData = res1.data.data;
          if (state.registerData != null&&state.registerData.isDoctor == "1") {
            doctorButton.value = true;
          }
          goToUserInfo.value = true;
        } else if (binding == 60000) {
          hospIdShow.value = false;
          state.registerData = res1.data.data;
          console.log(state.registerData);
          if (state.registerData != null && state.registerData.isDoctor == "1") {
            doctorButton.value = true;
          }
          goToUserInfo.value = true;
        } else if (binding == 40000) {
          showOverlay.value = true;
          bingingNotice.value = "【登陆异常】：请您在微信端打开";
          goToAbout.value = true;
        } else {
          getPersonInit().then((res2) => {
            state.registerData = res2.data.data;
            if (state.registerData.hospitalCode != null) {
              hospIdShow.value = true;
            }
            if (state.registerData.phone != null) {
              submitContext.value = "审核已通过";
              buttonShow.value = true;
            }
            if (state.registerData.isDoctor == "1") {
              doctorButton.value = true;
            }
            console.log(state.registerData);
          });
          getUserRiskInfo().then((res3) => {
            console.log(res3.data.data);
            question.userRiskInfoVo=res3.data.data;
            //result.value=question.userRiskInfoVo.birthday;
            //if(question.userRiskInfoVo.birthday!=null){
            //  const myArray = question.userRiskInfoVo.birthday.split("/");
            //  currentDate.value=myArray;
            //}

          });
        }
      });
    });
    return {
      hosp,
      kpianawait,
      ...toRefs(state),
      getData,
      getNewData,
      getQueSave,
      showBinging,
      active,
      submitContext,
      goToAbout,
      bingingNotice,
      showOverlay,
      buttonShow,
      doctorButton,
      goToUserInfo,
      hospIdShow,
      informedRes,
      question,
      result,
      onConfirm,
      currentDate,
      minDate: new Date(1920, 0, 1),
      maxDate: new Date(2010, 0, 1),
      columnsType,
      showPicker,
    };
  },
};
</script>
<style scoped lang="css" src="./assets/index.css" />
